module.exports = require("bn.js");